import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { HeaderComponent } from '../layout/header/header.component';
import { HeaderStyle } from '../layout/header/header.desktop.responsive';
import { ArticleDetailComponent, ArticlesActions, articlesFeature } from './';

@Component({
  selector: 'dmcom-article-detail-page',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ArticleDetailComponent, HeaderComponent],
  template: `
    <dmcom-header [headerStyle]="HeaderStyle.gradient"></dmcom-header>

    <div class="article-detail-page scrollable-component">
      <!-- Spacer div -->
      <div class="top-spacer"></div>

      <!-- Article Detail Component -->
      <dmcom-article-detail
        [articleData]="selectedArticle()"
      ></dmcom-article-detail>

      <div
        class="absolute bottom-0 left-0 right-0 h-20 pointer-events-none"
        style="background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.80) 50%, #FFF 100%);"
      ></div>
    </div>
  `,
  styles: [
    `
      .article-detail-page {
        height: calc(100%);
        width: 100%;
        background: transparent;
        overflow-y: auto;
        margin-top: 20px;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }

      .top-spacer {
        height: 72px;
        width: 100%;
        flex-shrink: 0;
      }
    `,
  ],
})
export class ArticleDetailPageComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  public readonly articles = this.store.selectSignal(
    articlesFeature.selectArticles,
  );
  public readonly loading = this.store.selectSignal(
    articlesFeature.selectIsLoading,
  );
  public readonly error = this.store.selectSignal(articlesFeature.selectError);

  public selectedArticle = this.store.selectSignal(
    articlesFeature.selectSelectedArticle,
  );

  public readonly HeaderStyle = HeaderStyle;

  ngOnInit() {
    // Get article ID from route params
    this.route.params.subscribe((params) => {
      const nodeId = Number(params['node_id']);
      if (nodeId) {
        // Always fetch from API to get the complete article with content
        this.store.dispatch(ArticlesActions.loadArticleByNodeId({ nodeId }));
      }
    });
  }

  goBack(): void {
    window.history.back();
  }
}
